export default "0937f3a4047dedb9.svg"